import { API } from "@/main";

const state = {};

const getters = {};

const actions = {
  BEST_ROUTE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.best_route.create(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  BEST_ROUTE_FINAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.best_route.generate(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

const mutations = {};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/bestRoute.js